import React, { Component } from "react";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
import Papa from 'papaparse';
import '../../OrganizationSetup.css';
import { mapType } from "../../../../utils/constants";

export default class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {
        value: this.props.file,
        error: false,
        errorMessage: ''
      },
      fileName: ''
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleFileUpload = ({target}) => {
    if(target.files[0]){
      let {allowedFileSize, uploadFileHint} = this.props;
      let file = target.files[0];
      let fileExtension = file.name.split('.')[file.name.split('.').length - 1];
      if(!['csv'].includes(fileExtension.toLowerCase())) {
        this.setState({file: {value: '', error: true, errorMessage: `${uploadFileHint}`}});
      } else if(file.size > (1024 * 1024 * allowedFileSize)) {
        this.setState({file: {value: '', error: true, errorMessage: `Upload file size is more that ${allowedFileSize}MB`}});
      } else {
        this.setState({file: {value: file, error: false, errorMessage: ''}, fileName: file.name});
      }
    }
  }

  processFile = () => {
    let csvFile = this.state.file.value;
    if (!csvFile || !csvFile.name) {
      this.setState({file: {value: csvFile, error: true, errorMessage: 'Please select file.'}})
    } else {
      Papa.parse(csvFile, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines:'greedy',
        complete: this.handleCsvParseComplete
      });
    }
  }

  handleCsvParseComplete = (result,file) => {
    const { fields } = result.meta;
    const {data} = result;
    this.props.onFileUpload(fields, data, this.state.file.value);
   }

  render() {
    let {instruction, labelSize, labelText, top, uploadFileHint, errorMessage, type} = this.props;
    let continueBtnOffset = 0;
    const {isRepeatFlow} = this.props;
    if(type === mapType.orgChart || type === mapType.gender || isRepeatFlow) {
      continueBtnOffset = 6;
    }
    let {file} = this.state;
    // console.log(isRepeatFlow);
    return (<div className={top}>
      <Row><Col><span className="upload-file-instruction">{instruction}</span></Col></Row>
      <Row className="mt40 upload-file-container-data">
        <Col sm={labelSize} className="upload-file-type-lable">{labelText}</Col>
        <Col sm={12-labelSize}>
            <Label for="file-upload" className="custom-file-upload" style={{marginBottom: '0'}}>
                <span className="select-file">Select File</span>
            </Label>
            <input id="file-upload" onChange={this.handleFileUpload} type="file" accept=".csv,.CSV"/>
            <span className="ml20 no-file-chosen-mapping">{(file.value && file.value!=="" && file.value.name) ? file.value.name : 'No File Chosen'}</span>
            <FormText style={{marginTop: '5px'}}>
            <span className="upload-file-hint">
              {uploadFileHint}</span>
            </FormText>
            {file.error ? <span className="upload-file-err-msg">{file.errorMessage}</span> : null}
        </Col>
      </Row>
      <Row className="mt40">
        <Col sm={{ size: '6', offset: 6 }}>
          <Row>
            {
              !isRepeatFlow ? 
                (type === mapType.positions || 
                type === mapType.performance ||
                type === mapType.separation) && <Col sm={{ size: '6' }}>
                <Button
                  className="float-right uploadFileSkipBtn w100"
                  onClick={this.props.onSkipStep}
                >
                  <span className="uploadFileSkipBtnTxt">Skip Mapping</span>
                </Button>
              </Col> : null
            }
            <Col sm={{ size: '6', offset: continueBtnOffset }}>
              <Button
                className="float-right continueBtn w100"
                onClick={this.processFile}
              >
                <span className="continueBtnTxt">Continue <span className="ml10 flaticon-next"></span></span>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>);
  }
}
